// Redux Reducer

import {  LOGIN_SUCCESS, 
          LOGIN_FAIL,  
          GET_USER_SUCCESS, 
          GET_USER_FAIL, 
          CREATE_PROPERTY_SUCCESS, 
          CREATE_PROPERTY_FAIL, 
          GET_ALL_USERS_SUCCESS, 
          GET_ALL_USERS_FAIL,
          UPDATE_MAP_LOCATION,
          UPLOAD_IMAGE_SUCCESS,
          UPLOAD_IMAGE_FAIL,
          GET_PROPERTIES_BY_SELLER_ID_SUCCESS,
          GET_PROPERTIES_BY_SELLER_ID_FAIL,
          EDIT_PROPERTY_REQUEST,
          EDIT_PROPERTY_SUCCESS,
          EDIT_PROPERTY_FAIL,
          GET_PROPERTY_BY_ID,
          GET_PROPERTIES_PENDING_SUCCESS, 
          GET_PROPERTIES_PENDING_FAIL,
          GET_PROPERTIES_LIST_SUCCESS,
          GET_PROPERTIES_LIST_FAIL, 
          CREATE_USER_REQUEST,
          CREATE_USER_SUCCESS,
          CREATE_USER_FAIL,
          GET_ALL_SELLERS_SUCCESS,
          GET_ALL_SELLERS_FAIL,
          UPDATE_SELLER_REQUEST,
          UPDATE_SELLER_SUCCESS,
          UPDATE_SELLER_FAIL,
          GET_SELLER_BY_ID_REQUEST,
          GET_SELLER_BY_ID_SUCCESS,
          GET_SELLER_BY_ID_FAILURE,
          CREATE_VISITA_REQUEST,
          CREATE_VISITA_SUCCESS,
          CREATE_VISITA_FAIL,
          GET_ALL_VISITAS_REQUEST,
          GET_ALL_VISITAS_SUCCESS,
          GET_ALL_VISITAS_FAIL,
          GET_VISITAS_BY_PROPERTY_REQUEST,
          GET_VISITAS_BY_PROPERTY_SUCCESS,
          GET_VISITAS_BY_PROPERTY_FAIL,
          GET_PROPERTIES_BY_SELLER,
          GET_PROPERTIES_BY_SELLER_ERROR,
          GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS,
          GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL,
          FETCH_RENTALS_REQUEST,
          FETCH_RENTALS_SUCCESS,
          FETCH_RENTALS_FAILURE,
          FETCH_RENTAL_REQUEST,
          FETCH_RENTAL_SUCCESS,
          FETCH_RENTAL_FAILURE,
          CREATE_RENTAL_REQUEST,
          CREATE_RENTAL_SUCCESS,
          CREATE_RENTAL_FAILURE,
          UPDATE_RENTAL_REQUEST,
          UPDATE_RENTAL_SUCCESS,
          UPDATE_RENTAL_FAILURE,
          DELETE_RENTAL_REQUEST,
          DELETE_RENTAL_SUCCESS,
          DELETE_RENTAL_FAILURE,
          GET_CLOSED_PROPERTIES_SUCCESS,
          GET_CLOSED_PROPERTIES_FAIL,   
          SESSION_STARTED,
          SESSION_ENDED,
          SESSION_HISTORY_SUCCESS,
          SESSION_HISTORY_FAIL,
          SESSION_MONTHLY_SUCCESS,
          SESSION_MONTHLY_FAIL,
          FETCH_EVENTS_REQUEST, FETCH_EVENTS_SUCCESS, FETCH_EVENTS_FAIL,
          CREATE_EVENT_REQUEST, CREATE_EVENT_SUCCESS, CREATE_EVENT_FAIL,
          UPDATE_EVENT_REQUEST, UPDATE_EVENT_SUCCESS, UPDATE_EVENT_FAIL,
          DELETE_EVENT_REQUEST, DELETE_EVENT_SUCCESS, DELETE_EVENT_FAIL,
          FETCH_UPCOMING_EVENTS_REQUEST, FETCH_UPCOMING_EVENTS_SUCCESS, FETCH_UPCOMING_EVENTS_FAIL,
          FETCH_EVENT_BY_ID_REQUEST, FETCH_EVENT_BY_ID_SUCCESS, FETCH_EVENT_BY_ID_FAIL,
          MARK_EVENT_SEEN_REQUEST, MARK_EVENT_SEEN_SUCCESS, MARK_EVENT_SEEN_FAIL,
          CHANGE_EVENT_STATUS_REQUEST, CHANGE_EVENT_STATUS_SUCCESS, CHANGE_EVENT_STATUS_FAIL,
          CREATE_CLIENT_REQUEST, CREATE_CLIENT_SUCCESS, CREATE_CLIENT_FAIL,
          GET_CLIENTS_BY_SELLER_REQUEST, GET_CLIENTS_BY_SELLER_SUCCESS, GET_CLIENTS_BY_SELLER_FAIL,
          GET_ALL_CLIENTS_REQUEST, GET_ALL_CLIENTS_SUCCESS, GET_ALL_CLIENTS_FAIL,
          GET_CLIENT_BY_ID_REQUEST, GET_CLIENT_BY_ID_SUCCESS, GET_CLIENT_BY_ID_FAIL,
          UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAIL,
          DELETE_CLIENT_REQUEST, DELETE_CLIENT_SUCCESS, DELETE_CLIENT_FAIL,
          ASSOCIATE_CLIENT_PROPERTY_REQUEST, ASSOCIATE_CLIENT_PROPERTY_SUCCESS, ASSOCIATE_CLIENT_PROPERTY_FAIL,
          GET_CLIENTS_BY_PROPERTY_REQUEST, GET_CLIENTS_BY_PROPERTY_SUCCESS, GET_CLIENTS_BY_PROPERTY_FAIL,
          // Rental Management action types
          FETCH_RENTAL_DASHBOARD_REQUEST, FETCH_RENTAL_DASHBOARD_SUCCESS, FETCH_RENTAL_DASHBOARD_FAIL,
          FETCH_ACTIVE_RENTALS_REQUEST, FETCH_ACTIVE_RENTALS_SUCCESS, FETCH_ACTIVE_RENTALS_FAIL,
          FETCH_RENTAL_DETAIL_REQUEST, FETCH_RENTAL_DETAIL_SUCCESS, FETCH_RENTAL_DETAIL_FAIL,
          FETCH_OVERDUE_PAYMENTS_REQUEST, FETCH_OVERDUE_PAYMENTS_SUCCESS, FETCH_OVERDUE_PAYMENTS_FAIL,
          FETCH_EXPIRING_CONTRACTS_REQUEST, FETCH_EXPIRING_CONTRACTS_SUCCESS, FETCH_EXPIRING_CONTRACTS_FAIL,
          GENERATE_PAYMENT_SCHEDULE_REQUEST, GENERATE_PAYMENT_SCHEDULE_SUCCESS, GENERATE_PAYMENT_SCHEDULE_FAIL,
          FETCH_RENTAL_PAYMENTS_REQUEST, FETCH_RENTAL_PAYMENTS_SUCCESS, FETCH_RENTAL_PAYMENTS_FAIL,
          REGISTER_PAYMENT_REQUEST, REGISTER_PAYMENT_SUCCESS, REGISTER_PAYMENT_FAIL,
          UPDATE_OVERDUE_PAYMENTS_REQUEST, UPDATE_OVERDUE_PAYMENTS_SUCCESS, UPDATE_OVERDUE_PAYMENTS_FAIL,
          CREATE_RENTAL_ADJUSTMENT_REQUEST, CREATE_RENTAL_ADJUSTMENT_SUCCESS, CREATE_RENTAL_ADJUSTMENT_FAIL,
          SIMULATE_RENTAL_ADJUSTMENT_REQUEST, SIMULATE_RENTAL_ADJUSTMENT_SUCCESS, SIMULATE_RENTAL_ADJUSTMENT_FAIL,
          FETCH_ADJUSTMENT_HISTORY_REQUEST, FETCH_ADJUSTMENT_HISTORY_SUCCESS, FETCH_ADJUSTMENT_HISTORY_FAIL,
          FETCH_UPCOMING_ADJUSTMENTS_REQUEST, FETCH_UPCOMING_ADJUSTMENTS_SUCCESS, FETCH_UPCOMING_ADJUSTMENTS_FAIL,
          NOTIFY_ADJUSTMENT_REQUEST, NOTIFY_ADJUSTMENT_SUCCESS, NOTIFY_ADJUSTMENT_FAIL,
          CREATE_RENTAL_TENANT_REQUEST, CREATE_RENTAL_TENANT_SUCCESS, CREATE_RENTAL_TENANT_FAIL,
          FETCH_RENTAL_TENANTS_REQUEST, FETCH_RENTAL_TENANTS_SUCCESS, FETCH_RENTAL_TENANTS_FAIL,
          UPDATE_RENTAL_TENANT_REQUEST, UPDATE_RENTAL_TENANT_SUCCESS, UPDATE_RENTAL_TENANT_FAIL,
          DELETE_RENTAL_TENANT_REQUEST, DELETE_RENTAL_TENANT_SUCCESS, DELETE_RENTAL_TENANT_FAIL,
          CLEAR_RENTAL_STATE, SET_RENTAL_LOADING,
          // Estadísticas action types
          FETCH_VISITAS_STATS_REQUEST, FETCH_VISITAS_STATS_SUCCESS, FETCH_VISITAS_STATS_FAIL,
          FETCH_VISITAS_STATS_PERIOD_REQUEST, FETCH_VISITAS_STATS_PERIOD_SUCCESS, FETCH_VISITAS_STATS_PERIOD_FAIL,
          FETCH_SELLERS_STATS_REQUEST, FETCH_SELLERS_STATS_SUCCESS, FETCH_SELLERS_STATS_FAIL,
          FETCH_REUNIONES_RANKING_REQUEST, FETCH_REUNIONES_RANKING_SUCCESS, FETCH_REUNIONES_RANKING_FAIL,
          FETCH_REUNIONES_INFORME_REQUEST, FETCH_REUNIONES_INFORME_SUCCESS, FETCH_REUNIONES_INFORME_FAIL,
          FETCH_REUNIONES_TIPS_REQUEST, FETCH_REUNIONES_TIPS_SUCCESS, FETCH_REUNIONES_TIPS_FAIL,
          CREATE_REUNION_REQUEST, CREATE_REUNION_SUCCESS, CREATE_REUNION_FAIL,
          UPDATE_REUNION_REQUEST, UPDATE_REUNION_SUCCESS, UPDATE_REUNION_FAIL,
          DELETE_REUNION_REQUEST, DELETE_REUNION_SUCCESS, DELETE_REUNION_FAIL,
          FETCH_REUNIONES_LIST_REQUEST, FETCH_REUNIONES_LIST_SUCCESS, FETCH_REUNIONES_LIST_FAIL,
          FETCH_ACTIVE_SELLERS_REQUEST, FETCH_ACTIVE_SELLERS_SUCCESS, FETCH_ACTIVE_SELLERS_FAIL,
          FETCH_VISITAS_AGENT_STATS_REQUEST, FETCH_VISITAS_AGENT_STATS_SUCCESS, FETCH_VISITAS_AGENT_STATS_FAIL,
          CLEAR_ESTADISTICAS_STATE,
          // Visitas Externas
          CREATE_VISITA_EXTERNA_REQUEST, CREATE_VISITA_EXTERNA_SUCCESS, CREATE_VISITA_EXTERNA_FAIL,
          GET_VISITAS_EXTERNAS_REQUEST, GET_VISITAS_EXTERNAS_SUCCESS, GET_VISITAS_EXTERNAS_FAIL,
          GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST, GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS, GET_VISITAS_EXTERNAS_BY_AGENT_FAIL,
          UPDATE_VISITA_EXTERNA_REQUEST, UPDATE_VISITA_EXTERNA_SUCCESS, UPDATE_VISITA_EXTERNA_FAIL,
          DELETE_VISITA_EXTERNA_REQUEST, DELETE_VISITA_EXTERNA_SUCCESS, DELETE_VISITA_EXTERNA_FAIL,
          CREATE_OPERACION_EXTERNA_REQUEST, CREATE_OPERACION_EXTERNA_SUCCESS, CREATE_OPERACION_EXTERNA_FAIL,
          GET_OPERACIONES_EXTERNAS_REQUEST, GET_OPERACIONES_EXTERNAS_SUCCESS, GET_OPERACIONES_EXTERNAS_FAIL,
          GET_OPERACION_EXTERNA_BY_ID_REQUEST, GET_OPERACION_EXTERNA_BY_ID_SUCCESS, GET_OPERACION_EXTERNA_BY_ID_FAIL,
          UPDATE_OPERACION_EXTERNA_REQUEST, UPDATE_OPERACION_EXTERNA_SUCCESS, UPDATE_OPERACION_EXTERNA_FAIL,
          DELETE_OPERACION_EXTERNA_REQUEST, DELETE_OPERACION_EXTERNA_SUCCESS, DELETE_OPERACION_EXTERNA_FAIL
         } from './Actions/actionTypes';

const initialState = {
  properties: [],
  user: JSON.parse(localStorage.getItem('user')) || null,
  userId: localStorage.getItem('userId') || null,
  userType: localStorage.getItem('userType') || null,
  userDetails: null,
  users: [],
  propertyCreationError: null,
  mapLocation: null,
  imageUploadError: null,
  propertiesBySellerId: [],
  propertiesClosedBySellerId: [],
  property: null,
  pendingProperties: [], 
  activeProperties: [], 
  seller: null,
  sellers: [],
  sellerProperties: {},
  selleredit: null,
  loading: false,
  error: null,
  visitas: [],
  rentals: [], 
  rental: null, 
  closedProperties: [],
  sessionId: null,
  historyByUser: {}, // { [userId]: [array de sesiones] }
  monthlyStatsByUser: {}, // { [userId]: {month, totalMinutes, sessionCount} }
  events: [],
  eventsLoading: false,
  eventsError: null,
  upcomingEvents: [],
  upcomingEventsLoading: false,
  currentEvent: null,
  // Client state
  clients: [],
  clientsBySeller: [],
  clientsByProperty: [],
  currentClient: null,
  clientsLoading: false,
  clientsError: null,
  // Rental Management state
  rentalDashboard: null,
  activeRentals: [],
  rentalDetail: null,
  overduePayments: [],
  expiringContracts: [],
  rentalPayments: [],
  adjustmentHistory: [],
  upcomingAdjustments: [],
  rentalTenants: [],
  adjustmentSimulation: null,
  rentalsLoading: false,
  rentalsError: null,
  // Rental Management state
  rentalDashboard: null,
  activeRentals: [],
  rentalDetail: null,
  overduePayments: [],
  expiringContracts: [],
  rentalPayments: [],
  adjustmentHistory: [],
  upcomingAdjustments: [],
  rentalTenants: [],
  adjustmentSimulation: null,
  rentalsLoading: false,
  rentalsError: null,
  // Estadísticas state
  visitasStats: null,
  visitasStatsPeriod: null,
  visitasAgentStats: null,
  sellersStats: null,
  reunionesRanking: null,
  reunionesInforme: null,
  reunionesTips: null,
  reunionesList: null,
  activeSellers: null,
  estadisticasLoading: false,
  estadisticasError: null,
  reunionCrudLoading: false,
  reunionCrudError: null,
  // Visitas Externas state
  visitasExternas: [],
  visitasExternasLoading: false,
  visitasExternasError: null,
  // Operaciones Externas (Punta Compradora) state
  operacionesExternas: [],
  operacionExternaDetail: null,
  operacionesExternasLoading: false,
  operacionesExternasError: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        userId: action.payload.userId,
        error: null
      };
    case LOGIN_FAIL:
      return {
        ...state,
        user: null,
        error: action.payload
      };
      case GET_USER_SUCCESS:
        return {
          ...state,
          userDetails: action.payload,
          error: null
        };
      case GET_USER_FAIL:
        return {
          ...state,
          userDetails: null,
          error: action.payload
        };
        case 'CREATE_PROPERTY_REQUEST':
          return {
              ...state,
              loading: true,
          };
      case 'CREATE_PROPERTY_SUCCESS':
          return {
              ...state,
              loading: false,
              property: action.payload,
              error: null,
          };
      case 'CREATE_PROPERTY_FAIL':
          return {
              ...state,
              loading: false,
              error: action.payload,
          };
      case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        error: null,
      };
    case GET_ALL_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
      case UPDATE_MAP_LOCATION:
        return {
          ...state,
          mapLocation: action.payload,
        };
        case UPLOAD_IMAGE_SUCCESS:
          return {
            ...state,
            imageUploadError: null,
            // Actualizar el estado según sea necesario para la carga de imágenes exitosa
          };
        case UPLOAD_IMAGE_FAIL:
          return {
            ...state,
            imageUploadError: action.payload,
            // Manejar la acción de carga de imágenes fallida
          };
          case GET_PROPERTIES_BY_SELLER_ID_SUCCESS:
      return {
        ...state,
        propertiesBySellerId: action.payload,
        error: null
      };
    case GET_PROPERTIES_BY_SELLER_ID_FAIL:
      return {
        ...state,
        propertiesBySellerId: [],
        error: action.payload
      };
      case GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS:
      return {
        ...state,
        propertiesClosedBySellerId: action.payload,
        error: null
      };
    case GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL:
      return {
        ...state,
        propertiesClosedBySellerId: [],
        error: action.payload
      };
      case EDIT_PROPERTY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EDIT_PROPERTY_SUCCESS:
      return {
        ...state,
        properties: state.properties.map((property) =>
          property.id === action.payload.id ? action.payload : property
        ),
        loading: false,
        error: null,
      };
    case EDIT_PROPERTY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case GET_PROPERTY_BY_ID:
        return {
          ...state,
          property: action.payload,
        };
        case GET_PROPERTIES_PENDING_SUCCESS:
          return {
            ...state,
            pendingProperties: action.payload,
            loading: false,
          };
    
        case GET_PROPERTIES_PENDING_FAIL:
          return {
            ...state,
            error: action.payload,
            loading: false,
          };
          case GET_PROPERTIES_LIST_SUCCESS:
            return {
              ...state,
              activeProperties: action.payload,
              loading: false,
            };
      
          case GET_PROPERTIES_LIST_FAIL:
            return {
              ...state,
              error: action.payload,
              loading: false,
            };
            case CREATE_USER_REQUEST:
              return { ...state, loading: true };
        
            case CREATE_USER_SUCCESS:
              return { ...state, loading: false, seller: action.payload };
        
            case CREATE_USER_FAIL:
              return { ...state, loading: false, error: action.payload };
              case GET_ALL_SELLERS_SUCCESS:
                return {
                  ...state,
                  sellers: action.payload, // Guarda la lista de vendedores en el estado
                  error: null
                };
              case GET_ALL_SELLERS_FAIL:
                return {
                  ...state,
                  sellers: [], // Limpia la lista de vendedores en caso de fallo
                  error: action.payload
                };
                case UPDATE_SELLER_REQUEST:
                  return {
                    ...state,
                    loading: true,
                    error: null,
                  };
                  
                case UPDATE_SELLER_SUCCESS:
                  return {
                    ...state,
                    sellers: Array.isArray(state.sellers) 
                      ? state.sellers.map((seller) => 
                          seller.id === action.payload.id ? action.payload : seller
                        )
                      : [],  // Aseguramos que sellers sea siempre un array
                    loading: false,
                    error: null,
                  };
            
                case UPDATE_SELLER_FAIL:
                  return {
                    ...state,
                    loading: false,
                    error: action.payload,
                  };
                  case CREATE_VISITA_REQUEST:
                    case GET_ALL_VISITAS_REQUEST:
                    case GET_VISITAS_BY_PROPERTY_REQUEST:
                      return { ...state, loading: true };
                
                    case CREATE_VISITA_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        visitas: [...state.visitas, action.payload], // Añade la nueva visita
                      };
                
                    case GET_ALL_VISITAS_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        visitas: action.payload, // Carga todas las visitas
                      };
                
                    case GET_VISITAS_BY_PROPERTY_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        visitas: action.payload, // Carga visitas de una propiedad específica
                      };
                
                    case CREATE_VISITA_FAIL:
                    case GET_ALL_VISITAS_FAIL:
                    case GET_VISITAS_BY_PROPERTY_FAIL:
                      return {
                        ...state,
                        loading: false,
                        error: action.payload, // Manejo de errores
                      };
                      case GET_PROPERTIES_BY_SELLER:
                        return {
                          ...state,
                          sellerProperties: {
                            ...state.sellerProperties,
                            [action.payload.sellerId]: action.payload.properties, // Asigna las propiedades por sellerId
                          },
                        };
                      case GET_PROPERTIES_BY_SELLER_ERROR:
                        // Maneja otros errores si es necesario
                        return state; 
                        case FETCH_RENTALS_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case FETCH_RENTALS_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: action.payload, // Supongamos que payload es un array de rentas
                            error: null,
                          };
                        case FETCH_RENTALS_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case FETCH_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case FETCH_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rental: action.payload, // Supongamos que payload es un objeto de renta
                            error: null,
                          };
                        case FETCH_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case CREATE_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case CREATE_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: [...state.rentals, action.payload], // Agregar la nueva renta a la lista
                            error: null,
                          };
                        case CREATE_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case UPDATE_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case UPDATE_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: state.rentals.map((rental) =>
                              rental.id === action.payload.id ? action.payload : rental
                            ), // Actualizar la renta modificada
                            error: null,
                          };
                        case UPDATE_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case DELETE_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case DELETE_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: state.rentals.filter((rental) => rental.id !== action.payload), // Eliminar la renta
                            error: null,
                          };
                        case DELETE_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                          case GET_CLOSED_PROPERTIES_SUCCESS:
                            return {
                              ...state,
                              closedProperties: action.payload,
                              error: null,
                            };
                          case GET_CLOSED_PROPERTIES_FAIL:
                            return {
                              ...state,
                              closedProperties: [],
                              error: action.payload,
                            };
              case SESSION_STARTED:
      return { ...state, sessionId: action.payload, error: null };
    case SESSION_ENDED:
      return { ...state, sessionId: null, error: null };
    case SESSION_HISTORY_SUCCESS:
      return {
        ...state,
        historyByUser: {
          ...state.historyByUser,
          [action.payload.userId]: action.payload.history,
        },
        error: null,
      };
    case SESSION_HISTORY_FAIL:
      return { ...state, error: action.payload };
    case SESSION_MONTHLY_SUCCESS:
      return {
        ...state,
        monthlyStatsByUser: {
          ...state.monthlyStatsByUser,
          [action.payload.userId]: action.payload.stats,
        },
        error: null,
      };
    case SESSION_MONTHLY_FAIL:
      return { ...state, error: action.payload };
    
    // Eventos del calendario
    case FETCH_EVENTS_REQUEST:
    case CREATE_EVENT_REQUEST:
    case UPDATE_EVENT_REQUEST:
    case DELETE_EVENT_REQUEST:
    case FETCH_EVENT_BY_ID_REQUEST:
    case CHANGE_EVENT_STATUS_REQUEST:
      return { ...state, eventsLoading: true, eventsError: null };

    case FETCH_EVENTS_SUCCESS:
      return { ...state, events: action.payload, eventsLoading: false };

    case FETCH_EVENT_BY_ID_SUCCESS:
      return { ...state, currentEvent: action.payload, eventsLoading: false };

    case CREATE_EVENT_SUCCESS:
      return { ...state, events: [...state.events, action.payload], eventsLoading: false };

    case UPDATE_EVENT_SUCCESS:
    case CHANGE_EVENT_STATUS_SUCCESS:
      return {
        ...state,
        events: state.events.map(ev => ev.id === action.payload.id ? action.payload : ev),
        currentEvent: state.currentEvent?.id === action.payload.id ? action.payload : state.currentEvent,
        eventsLoading: false
      };

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(ev => ev.id !== action.payload),
        eventsLoading: false
      };

    case FETCH_EVENTS_FAIL:
    case CREATE_EVENT_FAIL:
    case UPDATE_EVENT_FAIL:
    case DELETE_EVENT_FAIL:
    case FETCH_EVENT_BY_ID_FAIL:
    case CHANGE_EVENT_STATUS_FAIL:
      return { ...state, eventsLoading: false, eventsError: action.payload };

    // Eventos próximos (notificaciones)
    case FETCH_UPCOMING_EVENTS_REQUEST:
      return { ...state, upcomingEventsLoading: true };
    case FETCH_UPCOMING_EVENTS_SUCCESS:
      return { ...state, upcomingEvents: action.payload, upcomingEventsLoading: false };
    case FETCH_UPCOMING_EVENTS_FAIL:
      return { ...state, upcomingEventsLoading: false };

    // Marcar evento como visto
    case MARK_EVENT_SEEN_REQUEST:
      return state;
    case MARK_EVENT_SEEN_SUCCESS: {
      const { eventoId, sellerId } = action.payload;
      return {
        ...state,
        upcomingEvents: state.upcomingEvents.map(ev => {
          if (ev.id === eventoId && ev.agentes) {
            return {
              ...ev,
              agentes: ev.agentes.map(a =>
                a.id === sellerId ? { ...a, EventoAgente: { ...a.EventoAgente, visto: true } } : a
              )
            };
          }
          return ev;
        })
      };
    }
    case MARK_EVENT_SEEN_FAIL:
      return state;

    // ============= CLIENT CASES =============

    // Create Client
    case CREATE_CLIENT_REQUEST:
    case GET_CLIENTS_BY_SELLER_REQUEST:
    case GET_ALL_CLIENTS_REQUEST:
    case GET_CLIENT_BY_ID_REQUEST:
    case UPDATE_CLIENT_REQUEST:
    case DELETE_CLIENT_REQUEST:
    case ASSOCIATE_CLIENT_PROPERTY_REQUEST:
    case GET_CLIENTS_BY_PROPERTY_REQUEST:
      return { ...state, clientsLoading: true, clientsError: null };

    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: [...state.clients, action.payload.data],
        clientsBySeller: [...state.clientsBySeller, action.payload.data],
        clientsLoading: false,
        clientsError: null
      };

    case GET_CLIENTS_BY_SELLER_SUCCESS:
      return {
        ...state,
        clientsBySeller: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case GET_ALL_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case GET_CLIENT_BY_ID_SUCCESS:
      return {
        ...state,
        currentClient: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map(client => 
          client.id === action.payload.data.id ? action.payload.data : client
        ),
        clientsBySeller: state.clientsBySeller.map(client => 
          client.id === action.payload.data.id ? action.payload.data : client
        ),
        currentClient: state.currentClient?.id === action.payload.data.id ? action.payload.data : state.currentClient,
        clientsLoading: false,
        clientsError: null
      };

    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map(client => 
          client.id === action.payload.clientId ? { ...client, activo: false } : client
        ),
        clientsBySeller: state.clientsBySeller.map(client => 
          client.id === action.payload.clientId ? { ...client, activo: false } : client
        ),
        clientsLoading: false,
        clientsError: null
      };

    case ASSOCIATE_CLIENT_PROPERTY_SUCCESS:
      return {
        ...state,
        clientsLoading: false,
        clientsError: null
      };

    case GET_CLIENTS_BY_PROPERTY_SUCCESS:
      return {
        ...state,
        clientsByProperty: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case CREATE_CLIENT_FAIL:
    case GET_CLIENTS_BY_SELLER_FAIL:
    case GET_ALL_CLIENTS_FAIL:
    case GET_CLIENT_BY_ID_FAIL:
    case UPDATE_CLIENT_FAIL:
    case DELETE_CLIENT_FAIL:
    case ASSOCIATE_CLIENT_PROPERTY_FAIL:
    case GET_CLIENTS_BY_PROPERTY_FAIL:
      return {
        ...state,
        clientsLoading: false,
        clientsError: action.payload
      };

    // ================ RENTAL MANAGEMENT CASES ================

    // Dashboard y vistas generales
    case FETCH_RENTAL_DASHBOARD_REQUEST:
    case FETCH_ACTIVE_RENTALS_REQUEST:
    case FETCH_RENTAL_DETAIL_REQUEST:
    case FETCH_OVERDUE_PAYMENTS_REQUEST:
    case FETCH_EXPIRING_CONTRACTS_REQUEST:
    case GENERATE_PAYMENT_SCHEDULE_REQUEST:
    case FETCH_RENTAL_PAYMENTS_REQUEST:
    case REGISTER_PAYMENT_REQUEST:
    case UPDATE_OVERDUE_PAYMENTS_REQUEST:
    case CREATE_RENTAL_ADJUSTMENT_REQUEST:
    case SIMULATE_RENTAL_ADJUSTMENT_REQUEST:
    case FETCH_ADJUSTMENT_HISTORY_REQUEST:
    case FETCH_UPCOMING_ADJUSTMENTS_REQUEST:
    case NOTIFY_ADJUSTMENT_REQUEST:
    case CREATE_RENTAL_TENANT_REQUEST:
    case FETCH_RENTAL_TENANTS_REQUEST:
    case UPDATE_RENTAL_TENANT_REQUEST:
    case DELETE_RENTAL_TENANT_REQUEST:
      return {
        ...state,
        rentalsLoading: true,
        rentalsError: null
      };

    case FETCH_RENTAL_DASHBOARD_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalDashboard: action.payload,
        rentalsError: null
      };

    case FETCH_ACTIVE_RENTALS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        activeRentals: action.payload,
        rentalsError: null
      };

    case FETCH_RENTAL_DETAIL_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalDetail: action.payload,
        rentalsError: null
      };

    case FETCH_OVERDUE_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        overduePayments: action.payload,
        rentalsError: null
      };

    case FETCH_EXPIRING_CONTRACTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        expiringContracts: action.payload,
        rentalsError: null
      };

    case GENERATE_PAYMENT_SCHEDULE_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: null
        // El schedule se genera automáticamente, se actualizará con fetchRentalPayments
      };

    case FETCH_RENTAL_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalPayments: action.payload,
        rentalsError: null
      };

    case REGISTER_PAYMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalPayments: state.rentalPayments.map(payment => 
          payment.id === action.payload.id ? action.payload : payment
        ),
        rentalsError: null
      };

    case UPDATE_OVERDUE_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: null
        // Los pagos se actualizarán automáticamente al refrescar la lista
      };

    case CREATE_RENTAL_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentHistory: [action.payload, ...state.adjustmentHistory],
        rentalsError: null
      };

    case SIMULATE_RENTAL_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentSimulation: action.payload,
        rentalsError: null
      };

    case FETCH_ADJUSTMENT_HISTORY_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentHistory: action.payload,
        rentalsError: null
      };

    case FETCH_UPCOMING_ADJUSTMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        upcomingAdjustments: action.payload,
        rentalsError: null
      };

    case NOTIFY_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentHistory: state.adjustmentHistory.map(adjustment => 
          adjustment.id === action.payload.id ? action.payload : adjustment
        ),
        rentalsError: null
      };

    case CREATE_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: [...state.rentalTenants, action.payload],
        rentalsError: null
      };

    case FETCH_RENTAL_TENANTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: action.payload,
        rentalsError: null
      };

    case UPDATE_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: state.rentalTenants.map(tenant => 
          tenant.id === action.payload.id ? action.payload : tenant
        ),
        rentalsError: null
      };

    case DELETE_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: state.rentalTenants.filter(tenant => 
          tenant.id !== action.payload.tenantId
        ),
        rentalsError: null
      };

    case FETCH_RENTAL_DASHBOARD_FAIL:
    case FETCH_ACTIVE_RENTALS_FAIL:
    case FETCH_RENTAL_DETAIL_FAIL:
    case FETCH_OVERDUE_PAYMENTS_FAIL:
    case FETCH_EXPIRING_CONTRACTS_FAIL:
    case GENERATE_PAYMENT_SCHEDULE_FAIL:
    case FETCH_RENTAL_PAYMENTS_FAIL:
    case REGISTER_PAYMENT_FAIL:
    case UPDATE_OVERDUE_PAYMENTS_FAIL:
    case CREATE_RENTAL_ADJUSTMENT_FAIL:
    case SIMULATE_RENTAL_ADJUSTMENT_FAIL:
    case FETCH_ADJUSTMENT_HISTORY_FAIL:
    case FETCH_UPCOMING_ADJUSTMENTS_FAIL:
    case NOTIFY_ADJUSTMENT_FAIL:
    case CREATE_RENTAL_TENANT_FAIL:
    case FETCH_RENTAL_TENANTS_FAIL:
    case UPDATE_RENTAL_TENANT_FAIL:
    case DELETE_RENTAL_TENANT_FAIL:
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: action.payload
      };

    case CLEAR_RENTAL_STATE:
      return {
        ...state,
        rentalDashboard: null,
        activeRentals: [],
        rentalDetail: null,
        overduePayments: [],
        expiringContracts: [],
        rentalPayments: [],
        adjustmentHistory: [],
        upcomingAdjustments: [],
        rentalTenants: [],
        adjustmentSimulation: null,
        rentalsLoading: false,
        rentalsError: null
      };

    case SET_RENTAL_LOADING:
      return {
        ...state,
        rentalsLoading: action.payload
      };

    // ================ ESTADÍSTICAS ================
    case FETCH_VISITAS_STATS_REQUEST:
    case FETCH_VISITAS_STATS_PERIOD_REQUEST:
    case FETCH_VISITAS_AGENT_STATS_REQUEST:
    case FETCH_SELLERS_STATS_REQUEST:
    case FETCH_REUNIONES_RANKING_REQUEST:
    case FETCH_REUNIONES_INFORME_REQUEST:
    case FETCH_REUNIONES_TIPS_REQUEST:
      return { ...state, estadisticasLoading: true, estadisticasError: null };

    case FETCH_VISITAS_STATS_SUCCESS:
      return { ...state, estadisticasLoading: false, visitasStats: action.payload };
    case FETCH_VISITAS_STATS_PERIOD_SUCCESS:
      return { ...state, estadisticasLoading: false, visitasStatsPeriod: action.payload };
    case FETCH_VISITAS_AGENT_STATS_SUCCESS:
      return { ...state, estadisticasLoading: false, visitasAgentStats: action.payload };
    case FETCH_SELLERS_STATS_SUCCESS:
      return { ...state, estadisticasLoading: false, sellersStats: action.payload };
    case FETCH_REUNIONES_RANKING_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesRanking: action.payload };
    case FETCH_REUNIONES_INFORME_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesInforme: action.payload };
    case FETCH_REUNIONES_TIPS_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesTips: action.payload };

    case FETCH_VISITAS_STATS_FAIL:
    case FETCH_VISITAS_STATS_PERIOD_FAIL:
    case FETCH_VISITAS_AGENT_STATS_FAIL:
    case FETCH_SELLERS_STATS_FAIL:
    case FETCH_REUNIONES_RANKING_FAIL:
    case FETCH_REUNIONES_INFORME_FAIL:
    case FETCH_REUNIONES_TIPS_FAIL:
      return { ...state, estadisticasLoading: false, estadisticasError: action.payload };

    case CLEAR_ESTADISTICAS_STATE:
      return {
        ...state,
        visitasStats: null,
        visitasStatsPeriod: null,
        visitasAgentStats: null,
        sellersStats: null,
        reunionesRanking: null,
        reunionesInforme: null,
        reunionesTips: null,
        reunionesList: null,
        activeSellers: null,
        estadisticasLoading: false,
        estadisticasError: null,
        reunionCrudLoading: false,
        reunionCrudError: null
      };

    // Reuniones CRUD
    case CREATE_REUNION_REQUEST:
    case UPDATE_REUNION_REQUEST:
    case DELETE_REUNION_REQUEST:
      return { ...state, reunionCrudLoading: true, reunionCrudError: null };

    case CREATE_REUNION_SUCCESS:
    case UPDATE_REUNION_SUCCESS:
      return { ...state, reunionCrudLoading: false };

    case DELETE_REUNION_SUCCESS:
      return { ...state, reunionCrudLoading: false };

    case CREATE_REUNION_FAIL:
    case UPDATE_REUNION_FAIL:
    case DELETE_REUNION_FAIL:
      return { ...state, reunionCrudLoading: false, reunionCrudError: action.payload };

    // Reuniones List
    case FETCH_REUNIONES_LIST_REQUEST:
      return { ...state, estadisticasLoading: true, estadisticasError: null };
    case FETCH_REUNIONES_LIST_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesList: action.payload };
    case FETCH_REUNIONES_LIST_FAIL:
      return { ...state, estadisticasLoading: false, estadisticasError: action.payload };

    // Active Sellers
    case FETCH_ACTIVE_SELLERS_REQUEST:
      return { ...state, estadisticasLoading: true };
    case FETCH_ACTIVE_SELLERS_SUCCESS:
      return { ...state, estadisticasLoading: false, activeSellers: action.payload };
    case FETCH_ACTIVE_SELLERS_FAIL:
      return { ...state, estadisticasLoading: false, estadisticasError: action.payload };

    // ================ VISITAS EXTERNAS ================
    case CREATE_VISITA_EXTERNA_REQUEST:
    case GET_VISITAS_EXTERNAS_REQUEST:
    case GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST:
    case UPDATE_VISITA_EXTERNA_REQUEST:
    case DELETE_VISITA_EXTERNA_REQUEST:
      return { ...state, visitasExternasLoading: true, visitasExternasError: null };

    case CREATE_VISITA_EXTERNA_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: [...state.visitasExternas, action.payload],
        visitasExternasError: null
      };

    case GET_VISITAS_EXTERNAS_SUCCESS:
    case GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: action.payload,
        visitasExternasError: null
      };

    case UPDATE_VISITA_EXTERNA_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: state.visitasExternas.map(v =>
          v.id === action.payload.id ? action.payload : v
        ),
        visitasExternasError: null
      };

    case DELETE_VISITA_EXTERNA_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: state.visitasExternas.filter(v => v.id !== action.payload),
        visitasExternasError: null
      };

    case CREATE_VISITA_EXTERNA_FAIL:
    case GET_VISITAS_EXTERNAS_FAIL:
    case GET_VISITAS_EXTERNAS_BY_AGENT_FAIL:
    case UPDATE_VISITA_EXTERNA_FAIL:
    case DELETE_VISITA_EXTERNA_FAIL:
      return { ...state, visitasExternasLoading: false, visitasExternasError: action.payload };

    // Operaciones Externas (Punta Compradora)
    case CREATE_OPERACION_EXTERNA_REQUEST:
    case GET_OPERACIONES_EXTERNAS_REQUEST:
    case GET_OPERACION_EXTERNA_BY_ID_REQUEST:
    case UPDATE_OPERACION_EXTERNA_REQUEST:
    case DELETE_OPERACION_EXTERNA_REQUEST:
      return { ...state, operacionesExternasLoading: true, operacionesExternasError: null };

    case CREATE_OPERACION_EXTERNA_SUCCESS:
      return { ...state, operacionesExternasLoading: false, operacionesExternas: [...state.operacionesExternas, action.payload] };

    case GET_OPERACIONES_EXTERNAS_SUCCESS:
      return { ...state, operacionesExternasLoading: false, operacionesExternas: action.payload };

    case GET_OPERACION_EXTERNA_BY_ID_SUCCESS:
      return { ...state, operacionesExternasLoading: false, operacionExternaDetail: action.payload };

    case UPDATE_OPERACION_EXTERNA_SUCCESS:
      return {
        ...state,
        operacionesExternasLoading: false,
        operacionesExternas: state.operacionesExternas.map(op => op.id === action.payload.id ? action.payload : op),
        operacionExternaDetail: action.payload,
      };

    case DELETE_OPERACION_EXTERNA_SUCCESS:
      return {
        ...state,
        operacionesExternasLoading: false,
        operacionesExternas: state.operacionesExternas.filter(op => op.id !== action.payload),
      };

    case CREATE_OPERACION_EXTERNA_FAIL:
    case GET_OPERACIONES_EXTERNAS_FAIL:
    case GET_OPERACION_EXTERNA_BY_ID_FAIL:
    case UPDATE_OPERACION_EXTERNA_FAIL:
    case DELETE_OPERACION_EXTERNA_FAIL:
      return { ...state, operacionesExternasLoading: false, operacionesExternasError: action.payload };

    default:
      return state;
  }
};


export default rootReducer;